/**
 * @generated SignedSource<<2b9e0efe38da96acc80763ab70169398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type coursePreviewFragment$data = {
  readonly canView: boolean;
  readonly certificate: {
    readonly file: {
      readonly signedUrl: string;
    };
    readonly id: string;
  } | null | undefined;
  readonly certificateEmission: boolean;
  readonly completed: boolean;
  readonly id: string;
  readonly landscapeImage: {
    readonly signedUrl: string;
  } | null | undefined;
  readonly name: string;
  readonly portraitImage: {
    readonly signedUrl: string;
  } | null | undefined;
  readonly primaryProduct: {
    readonly checkoutUrl: string | null | undefined;
    readonly enabled: boolean;
  } | null | undefined;
  readonly progress: number;
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"certificateEmitDialogFragment" | "coursePreview_paywall">;
  readonly " $fragmentType": "coursePreviewFragment";
};
export type coursePreviewFragment$key = {
  readonly " $data"?: coursePreviewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"coursePreviewFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "coursePreviewFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canView",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageFile",
      "kind": "LinkedField",
      "name": "landscapeImage",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageFile",
      "kind": "LinkedField",
      "name": "portraitImage",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "certificateEmission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentIntegrationProduct",
      "kind": "LinkedField",
      "name": "primaryProduct",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkoutUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Certificate",
      "kind": "LinkedField",
      "name": "certificate",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ObjectFile",
          "kind": "LinkedField",
          "name": "file",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "certificateEmitDialogFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "coursePreview_paywall"
    }
  ],
  "type": "Course",
  "abstractKey": null
};
})();

(node as any).hash = "569236f0a6c4f864c623551af8cf2bfb";

export default node;
